// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "context-3SXCy";
var _3 = "info-2fEdw";
var _4 = "warning-38tNB";
var _5 = "wrapper-EHnsM";
var _6 = "icon-2-NBv";
var _7 = "content-3svJU";
var _8 = "title-3FW4C";
var _9 = "text-2bwQZ";
var _a = "action-1fNMm";
export { _1 as "__esModule", _2 as "context", _3 as "info", _4 as "warning", _5 as "wrapper", _6 as "icon", _7 as "content", _8 as "title", _9 as "text", _a as "action" }
export default { "__esModule": _1, "context": _2, "info": _3, "warning": _4, "wrapper": _5, "icon": _6, "content": _7, "title": _8, "text": _9, "action": _a }
